import React, { useEffect, useState, useMemo } from "react";
import style from "./index.module.less";
import Popup from "@df-mobile/popup";
// import { FormInstance } from "antd-mobile/es/components/form";
import Icon from "dffl-icons";
import closeIcon from './imgs/close_icon.png';

interface BProps {
  visible: boolean;
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  closeable?: boolean
}

const BPopup = (props: BProps) => {
  const {visible, title, children, onClose, closeable=true} = props;
  if (!visible) return null;
  return <Popup
    visible={visible}
    destroyOnClose
    maskClosable={closeable}
    position="bottom"
    wrapClassName={style.bottomPopup}
    onClose={onClose}
  >
    <div className={style.header}>
      {/* <span
        onClick={onClose}
      >
        <Icon type="icon-a-navigationbar-left-outlined" />
      </span> */}
      <div>{title}</div>
      <div className={style.closePart} onClick={onClose}>
        <img src={closeIcon} alt="" />
      </div>
    </div>
    <div className={style['popup-content']}>
    {children}
    </div>
    
  </Popup>
}

export default BPopup;
